import { Component, Input, OnInit } from "@angular/core"
import { ModalRef } from "../../modal/modal-ref"
import { StudentAssignmentModel } from "../../../models/student-assignment/studentAssignment.model"
import { QuestionSlideModel } from "../../../models/student-assignment/slide.model"
import { StudentAssignmentService } from "../../../services/student-assignment.service"

@Component({
    selector: "app-student-assignment-submit-modal",
    templateUrl: "./student-assignment-submit-modal.component.html",
    styleUrls: ["./student-assignment-submit-modal.component.scss"],
})
export class StudentAssignmentSubmitModalComponent {
    @Input() public studentAssignment: StudentAssignmentModel
    @Input() public preview: boolean = false
    public isSubmitEnabled = true

    constructor(
        public activeModal: ModalRef,
        private assignmentService: StudentAssignmentService
    ) {}

    public submit() {
        this.isSubmitEnabled = false
        this.assignmentService
            .completeAssignment(this.studentAssignment.resultId, this.preview)
            .subscribe((res) => {
                // @ts-ignore
                if (res.completed || this.preview) {
                    this.assignmentService.assignmentCompleted.next(true)
                    this.activeModal.close()
                }
            })
    }

    public isQuestionSlide(slide) {
        return slide instanceof QuestionSlideModel
    }

    public getUnansweredQuestions(slide) {
        const questions: string[] = []

        slide.questions.forEach((question, index) => {
            if (!question.hasAnswer()) {
                questions.push(`Q${index + 1}`)
            }
        })

        return questions.join(", ")
    }

    public closeModal() {
        this.activeModal.close()
        this.assignmentService.setModalClosed(false)
    }
}
